import { useEffect, useRef, useCallback } from 'react'

// Audio instance singleton
let audioInstance = null

const getAudio = () => {
    if (!audioInstance) {
        audioInstance = new Audio('/music.mp3')
        audioInstance.loop = true
        audioInstance.volume = 0.3
    }
    return audioInstance
}

// Background music hook
export const useBackgroundMusic = () => {
    const playMusic = useCallback(() => {
        const audio = getAudio()
        if (audio.paused) {
            audio.play().catch(() => {
                // Auto-play blocked
            })
        }
    }, [])

    return { playMusic }
}

export default useBackgroundMusic
